import React from "react";
import { loginFragments } from "./style";

export const CopyRight = ({}) => {
  const classes = loginFragments();
  return (
    <p className={classes.CopyRight}>
      Copyright © 2021 PoloTMS. All Rights Reserved.
    </p>
  );
};
